export default {"src":"/_next/static/media/phone.bce8e036.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};